import axios from "axios";
import dayjs from "dayjs";
import { EventEmitter } from "events";
import { createContext, useCallback, useContext, useState } from "react";
import { toast } from "react-toastify";

const StatsContext = createContext();
const StatsEvents = new EventEmitter();

export const StatsProvider = ({ children }) => {
  const [periodStatusStats, setPeriodStatusStats] = useState({});
  const [dailyStats, setDailyStats] = useState([]);
  const [monthlyStats, setMonthlyStats] = useState([]);
  const [regionsStats, setRegionsStats] = useState({
    deliveryByRegion: [],
    collectionByRegion: [],
  });
  const [periodLoading, setPeriodLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    startDate: dayjs(new Date()).format("YYYY-MM-DD"),
    endDate: dayjs(new Date()).format("YYYY-MM-DD"),
    partnerId: "",
    clientId: "",
  });

  const updateSearchParams = (newParams) => {
    setSearchParams((prev) => ({ ...prev, ...newParams }));
  };

  const getStatsPeriod = useCallback(async () => {
    try {
      setPeriodLoading(true);
      const params = {
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        partnerId: searchParams.partnerId,
        clientId: searchParams.clientId,
      };
      const { data } = await axios.get(`/stats/orders/period`, { params });
      setPeriodStatusStats(data.statusStats);
      setDailyStats(data.dailyStats);
      setMonthlyStats(data.monthlyStats);
      setRegionsStats(data.regionsStats);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error?.message || error.message;
      toast.error(errorMessage);
      throw error;
    } finally {
      setPeriodLoading(false);
    }
  }, [
    searchParams.startDate,
    searchParams.endDate,
    searchParams.partnerId,
    searchParams.clientId,
  ]);

  const value = {
    periodLoading,
    searchParams,
    periodStatusStats,
    dailyStats,
    monthlyStats,
    regionsStats,
    getStatsPeriod,
    updateSearchParams,
    OrderEvents: StatsEvents,
  };

  return (
    <StatsContext.Provider value={value}>{children}</StatsContext.Provider>
  );
};

export const useStatsContext = () => {
  const context = useContext(StatsContext);
  if (!context) {
    throw new Error("useStatsContext must be used within an StatsProvider");
  }
  return context;
};
